module.exports = __webpack_public_path__ + "img/icon_people.8f4722bc.svg";